import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from './useClient';
import { DisconnectResponse } from '@hud/slack-dtos/api';
import { SLACK_STATUS_KEY } from './useSlackStatus';
import useAnalytics from './useAnalytics';

export default function useRevokeSlackIntegrationMutation() {
  const { client } = useClient();
  const queryClient = useQueryClient();
  const analytics = useAnalytics();

  return useMutation({
    mutationFn: async () => {
      const response = await client.post<DisconnectResponse>('/slack/disconnect');
      return DisconnectResponse.parse(response.data);
    },
    onSuccess: () => {
      analytics.capture('slack_app_removed', {});
      queryClient.invalidateQueries({ queryKey: [SLACK_STATUS_KEY] });
    },
  });
}
